var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandMore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8766 9.00001L11.9966 12.88L8.11656 9.00001C7.92973 8.81275 7.67608 8.70752 7.41156 8.70752C7.14704 8.70752 6.89339 8.81275 6.70656 9.00001C6.31656 9.39001 6.31656 10.02 6.70656 10.41L11.2966 15C11.6866 15.39 12.3166 15.39 12.7066 15L17.2966 10.41C17.6866 10.02 17.6866 9.39001 17.2966 9.00001C16.9066 8.62001 16.2666 8.61001 15.8766 9.00001Z",
    fill: "#70768E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMore);
export default __webpack_public_path__ + "static/media/expand_more.6e439e7836265fb3ca392533ec1a361e.svg";
export { ForwardRef as ReactComponent };